import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5090/api';
const API_BASE = API_URL.replace(/\/api$/, '');

const API = axios.create({ baseURL: API_URL });

// Not: bir çağrı kendi X-Isletme-Id header'ını açıkça verdiyse (ör. admin'in Şablon Düzenle
// ekranından bir şablonu düzenlerken), bunu ez­MEsin — bu sayede müdür/garson panelinin kullandığı
// aynı uçlar, admin tarafından "sanki o işletmeymiş gibi" şablonlar için de kullanılabiliyor.
API.interceptors.request.use((config) => {
  const isletmeId = localStorage.getItem('isletmeId');
  if (isletmeId && !config.headers['X-Isletme-Id']) config.headers['X-Isletme-Id'] = isletmeId;
  // Yalnızca garson girişinde localStorage'da bulunur — masa bazlı hedefli push aboneliği için.
  const garsonId = localStorage.getItem('garsonId');
  if (garsonId && !config.headers['X-Garson-Id']) config.headers['X-Garson-Id'] = garsonId;
  return config;
});

export const dosyaUrl = (path) => (path ? `${API_BASE}${path}` : null);

// Admin
export const adminGirisYap = (kullaniciAdi, sifre) => API.post('/admin-auth/giris', { kullaniciAdi, sifre });
export const isletmeListesiGetir = () => API.get('/admin-isletme');
export const isletmeOlustur = (dto) => API.post('/admin-isletme', dto);
export const isletmeGuncelle = (id, dto) => API.put(`/admin-isletme/${id}`, dto);
export const isletmeSil = (id) => API.delete(`/admin-isletme/${id}`);

// Admin — Şablonlar (bağımsız bölüm; İşletmeler listesinden ayrı)
export const sablonYonetimListesi = () => API.get('/admin-sablon');
export const sablonYonetimOlustur = (ad) => API.post('/admin-sablon', { ad });
export const sablonYonetimGuncelle = (id, ad, tema) => API.put(`/admin-sablon/${id}`, { ad, tema });
export const sablonYonetimSil = (id) => API.delete(`/admin-sablon/${id}`);
export const sablonBannerYukle = (id, dosya) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post(`/admin-sablon/${id}/banner-yukle`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const sablonLogoYukle = (id, dosya) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post(`/admin-sablon/${id}/logo-yukle`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const sablonUrunGorselYukle = (id, dosya) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post(`/admin-sablon/${id}/urun-gorsel-yukle`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const sablonUrunGrupListesi = (id) => API.get(`/admin-sablon/${id}/urun-grup`);
export const sablonUrunGrupOlustur = (id, dto) => API.post(`/admin-sablon/${id}/urun-grup`, dto);
export const sablonUrunGrupGuncelle = (id, grupId, dto) => API.put(`/admin-sablon/${id}/urun-grup/${grupId}`, dto);
export const sablonUrunGrupSil = (id, grupId) => API.delete(`/admin-sablon/${id}/urun-grup/${grupId}`);
export const sablonUrunListesi = (id) => API.get(`/admin-sablon/${id}/urun`);
export const sablonUrunOlustur = (id, dto) => API.post(`/admin-sablon/${id}/urun`, dto);
export const sablonUrunGuncelle = (id, urunId, dto) => API.put(`/admin-sablon/${id}/urun/${urunId}`, dto);
export const sablonUrunSil = (id, urunId) => API.delete(`/admin-sablon/${id}/urun/${urunId}`);
export const sablonMasaListesi = (id) => API.get(`/admin-sablon/${id}/masa`);
export const sablonMasaOlustur = (id, ad) => API.post(`/admin-sablon/${id}/masa`, { ad });
export const sablonMasaGuncelle = (id, masaId, ad) => API.put(`/admin-sablon/${id}/masa/${masaId}`, { ad });
export const sablonMasaSil = (id, masaId) => API.delete(`/admin-sablon/${id}/masa/${masaId}`);
export const sablonGarsonListesi = (id) => API.get(`/admin-sablon/${id}/garson`);
export const sablonGarsonOlustur = (id, kullaniciAdi, sifre) => API.post(`/admin-sablon/${id}/garson`, { kullaniciAdi, sifre });
export const sablonGarsonSil = (id, garsonId) => API.delete(`/admin-sablon/${id}/garson/${garsonId}`);
export const sablonOnizlemeGetir = (id) => API.get(`/admin-sablon/${id}/onizleme`);

// İşletme (business) auth
export const isletmeGirisYap = (kullaniciAdi, sifre, isletmeKodu) => API.post('/isletme-auth/giris', { kullaniciAdi, sifre, isletmeKodu });

// Garson auth
export const garsonGirisYap = (kullaniciAdi, sifre, isletmeKodu) => API.post('/garson-auth/giris', { kullaniciAdi, sifre, isletmeKodu });

// Yeni hesap (SMS doğrulamalı kendi kendine kayıt)
export const kayitSmsYolla = (telefon) => API.post('/kayit/sms-yolla', { telefon });
export const kayitSmsDogrula = (telefon, kod) => API.post('/kayit/sms-dogrula', { telefon, kod });
export const kayitHesapOlustur = (dto) => API.post('/kayit/hesap-olustur', dto);

// Şablonlar (public — yeni hesap açılışındaki seçim listesi)
export const sablonListesi = () => API.get('/sablon/liste');

// Personel (garson) yönetimi — müdür panelinden; `config` verilirse (ör. admin'in şablon düzenleme
// ekranından) o işletme/şablon id'sine göre çalışır.
export const personelListesi = (config) => API.get('/personel', config);
export const personelOlustur = (dto, config) => API.post('/personel', dto, config);
export const personelAktifDegistir = (id, aktif, config) => API.put(`/personel/${id}/aktif?aktif=${aktif}`, null, config);
export const personelSil = (id, config) => API.delete(`/personel/${id}`, config);
export const personelMasaAtamalariGetir = (config) => API.get('/personel/masa-atamalari', config);
export const personelMasaAtamasiGuncelle = (id, masaIdleri, config) => API.put(`/personel/${id}/masalar`, masaIdleri, config);

// Public menü
export const menuGetir = (slug) => API.get(`/isletme/${slug}`);
export const isletmeMasalariGetir = (slug) => API.get(`/isletme/${slug}/masalar`);
export const isletmeGarsonlariGetir = (slug) => API.get(`/isletme/${slug}/garsonlar`);

// Ürün grubu
export const urunGrupListesi = (config) => API.get('/urun-grup', config);
export const urunGrupOlustur = (dto, config) => API.post('/urun-grup', dto, config);
export const urunGrupGuncelle = (id, dto, config) => API.put(`/urun-grup/${id}`, dto, config);
export const urunGrupSil = (id, config) => API.delete(`/urun-grup/${id}`, config);

// Ürün
export const urunListesi = (config) => API.get('/urun', config);
export const urunOlustur = (dto, config) => API.post('/urun', dto, config);
export const urunGuncelle = (id, dto, config) => API.put(`/urun/${id}`, dto, config);
export const urunSil = (id, config) => API.delete(`/urun/${id}`, config);
export const gorselYukle = (dosya, config) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post('/urun/gorsel-yukle', formData, { ...config, headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } });
};

// İşletme görünüm ayarları (banner/logo) + kendi bilgileri (lisans bitiş tarihi dahil)
export const isletmeBilgilerimGetir = (config) => API.get('/isletme-ayarlar', config);
export const bannerYukle = (dosya, config) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post('/isletme-ayarlar/banner-yukle', formData, { ...config, headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } });
};
export const logoYukle = (dosya, config) => {
  const formData = new FormData();
  formData.append('dosya', dosya);
  return API.post('/isletme-ayarlar/logo-yukle', formData, { ...config, headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } });
};

export const ipGuncelle = () => API.post('/isletme-ayarlar/ip-guncelle');
export const wifiBilgiGuncelle = (ssid, sifre) => API.put('/isletme-ayarlar/wifi-bilgi', { ssid, sifre });
export const fonksiyonAyarlariGuncelle = (siparisAyar, garsonCagirAyar, hesapIsteAyar) =>
  API.put('/isletme-ayarlar/fonksiyon-ayarlari', { siparisAyar, garsonCagirAyar, hesapIsteAyar });
export const googleYorumLinkiGuncelle = (link) => API.put('/isletme-ayarlar/google-yorum-link', { link });
export const isletmeBilgileriGuncelle = (dto) => API.put('/isletme-ayarlar/isletme-bilgileri', dto);

// Push bildirimi
export const pushPublicKeyGetir = () => API.get('/push/public-key');
export const pushAboneOl = (endpoint, p256dh, auth) => API.post('/push/abone-ol', { endpoint, p256dh, auth });
export const temaGuncelle = (tema) => API.put('/isletme-ayarlar/tema', { tema });

// Sipariş (sepet onayı — birden fazla ürün tek grup olarak gönderilir)
export const siparisVer = (slug, masaNo, aciklama, urunler) => API.post('/siparis', { slug, masaNo, aciklama, urunler });
export const masaSiparisleriGetir = (slug, masaNo) => API.get('/siparis/masa', { params: { slug, masaNo } });
export const musteriSiparisIptal = (id, slug, masaNo) => API.put(`/siparis/${id}/musteri-iptal`, { slug, masaNo });
export const siparisBekleyenListesi = () => API.get('/isletme-siparis/bekleyen');
export const siparisEskiListesi = () => API.get('/isletme-siparis/eski');
export const siparisHazirlaniyor = (id) => API.put(`/isletme-siparis/${id}/hazirlaniyor`);
export const siparisTeslimEdildi = (id) => API.put(`/isletme-siparis/${id}/teslim-edildi`);
export const siparisIptal = (id) => API.put(`/isletme-siparis/${id}/iptal`);

// İstatistikler
export const istatistikGetir = (params) => API.get('/istatistik', { params });

// Masalar
export const masaListesi = (config) => API.get('/masa', config);
export const masaOlustur = (ad, config) => API.post('/masa', { ad }, config);
export const masaGuncelle = (id, ad, config) => API.put(`/masa/${id}`, { ad }, config);
export const masaSil = (id, config) => API.delete(`/masa/${id}`, config);

// Bildirim (Garson Çağır / Hesap İste)
export const bildirimGonder = (slug, masaNo, tip) => API.post('/bildirim', { slug, masaNo, tip });
export const bildirimListesi = () => API.get('/isletme-bildirim');
export const bildirimOnayla = (id) => API.put(`/isletme-bildirim/${id}/onayla`);

// Adisyon
export const adisyonGetir = (masaNo) => API.get('/isletme-siparis/adisyon', { params: { masaNo } });
export const adisyonKapat = (masaNo) => API.put('/isletme-siparis/adisyon-kapat', null, { params: { masaNo } });

export default API;
